import { clsx } from "@/utils/styled";
import { theme } from "@/utils/theme";
import { cssClass } from "@vue-styled-components/core";
import { defineComponent, h } from "vue";

const loadingSpinnerClass = cssClass`
  mask-image: url("data:image/svg+xml,%3Csvg width='24' height='24' stroke='black' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform-origin='center'%3E%3Ccircle cx='12' cy='12' r='9.5' fill='none' stroke-width='3' stroke-linecap='round'%3E%3CanimateTransform attributeName='transform' type='rotate' from='0 12 12' to='360 12 12' dur='2s' repeatCount='indefinite'/%3E%3Canimate attributeName='stroke-dasharray' values='0,150;42,150;42,150' keyTimes='0;0.475;1' dur='1.5s' repeatCount='indefinite'/%3E%3Canimate attributeName='stroke-dashoffset' values='0;-16;-59' keyTimes='0;0.475;1' dur='1.5s' repeatCount='indefinite'/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
  aspect-ratio: 1;
  vertical-align: middle;
  background-color: ${theme.colors.white};
  display: inline-block;
  mask-position: 50%;
  mask-size: 100%;
  mask-repeat: no-repeat;
  width: 2rem;
`;

const authenticatingSlateClass = cssClass`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  gap: 1rem;
`;

const authenticatingSlateTextClass = cssClass`
  color: ${theme.colors.white};
  text-align: center;
  font-family: ${theme.fonts.sans};
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
`;

export const AuthenticatingSlate = defineComponent({
  setup() {
    return () =>
      h(
        "div",
        {
          class: clsx(authenticatingSlateClass),
        },
        [
          h("div", {
            class: clsx(loadingSpinnerClass),
          }),
          h(
            "p",
            {
              class: clsx(authenticatingSlateTextClass),
            },
            "Loading session...",
          ),
        ],
      );
  },
});
